import { css } from 'styled-components';

export const unsetButtonStyle = css`
  /** Reset button styling */
  all: unset;
  // Keep outline for accessibility
  outline: revert;
`;
